import React, { createContext, useState, useContext, useEffect } from 'react';
// import { verifySession } from '../App';


export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {

    const [isLoggedIn, setIsLoggedIn] = useState(false);

    useEffect(()=>{
        const sessionId = localStorage.getItem('UserSessionID');
        if (sessionId) {
            setIsLoggedIn(true);
        }
    }, [])
    

    return (
        <AuthContext.Provider value={{ isLoggedIn, setIsLoggedIn }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);